"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var ComponentIdSequence_1 = require("../ComponentIdSequence");
var NotConfiguredComponentFactory = function (type) {
    throw { code: "ILLEGAL_STATE", message: "A component factory has not been configured" };
};
var Component = /** @class */ (function () {
    function Component() {
        this._x = 0;
        this._y = 0;
        this._width = 0;
        this._height = 0;
    }
    Object.defineProperty(Component.prototype, "id", {
        get: function () {
            if (!this._id) {
                this._id = ComponentIdSequence_1.ComponentIdSequence.next();
            }
            return this._id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Component.prototype, "isWindowManager", {
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Component.prototype, "root", {
        get: function () {
            return this.parent ? this.parent.root : this;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Component.prototype, "x", {
        get: function () {
            return this._x;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Component.prototype, "rx", {
        get: function () {
            return this.x - (this.parent ? this.parent.x : 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Component.prototype, "y", {
        get: function () {
            return this._y;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Component.prototype, "ry", {
        get: function () {
            return this.y - (this.parent ? this.parent.y : 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Component.prototype, "width", {
        get: function () {
            return this._width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Component.prototype, "height", {
        get: function () {
            return this._height;
        },
        enumerable: true,
        configurable: true
    });
    Component.prototype.resize = function (width, height) {
        if ((width >= 0 && width !== this._width) || (height >= 0 && height !== this._height)) {
            this._width = width;
            this._height = height;
        }
    };
    Component.prototype.position = function (x, y) {
        this._x = x;
        this._y = y;
    };
    Component.prototype.setViewport = function (x, y, width, height) {
        this.position(x, y);
        this.resize(width, height);
    };
    Object.defineProperty(Component.prototype, "addApp", {
        get: function () {
            if (this._addApp !== undefined) {
                return this._addApp;
            }
            var p = this.parent;
            if (p === this) {
                console.warn("-- Ancestor Resolution Cycle Detected");
                return undefined;
            }
            return p ? p.addApp : undefined;
        },
        set: function (addApp) {
            this.setAddApp(addApp);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Component.prototype, "portalManager", {
        get: function () {
            if (this._portalManager !== undefined) {
                return this._portalManager;
            }
            var p = this.parent;
            if (p === this) {
                console.warn("-- Ancestor Resolution Cycle Detected");
                return undefined;
            }
            return p ? p.portalManager : undefined;
        },
        set: function (value) {
            this.setPortalManager(value);
        },
        enumerable: true,
        configurable: true
    });
    Component.prototype.setPortalManager = function (portalManager) {
        this._portalManager = portalManager;
    };
    Object.defineProperty(Component.prototype, "componentFactory", {
        get: function () {
            if (this._componentFactory !== undefined) {
                return this._componentFactory;
            }
            var p = this.parent;
            if (p === this) {
                console.warn("-- Ancestor Resolution Cycle Detected");
                return undefined;
            }
            return p ? p.componentFactory : NotConfiguredComponentFactory;
        },
        set: function (value) {
            this.setComponentFactory(value);
        },
        enumerable: true,
        configurable: true
    });
    Component.prototype.setComponentFactory = function (componentFactory) {
        this._componentFactory = componentFactory;
    };
    Component.prototype.setAddApp = function (addApp) {
        this._addApp = addApp;
    };
    Object.defineProperty(Component.prototype, "router", {
        get: function () {
            if (this._router !== undefined) {
                return this._router;
            }
            var p = this.parent;
            if (p === this) {
                console.warn("-- Ancestor Resolution Cycle Detected");
                return undefined;
            }
            return p ? p.router : undefined;
        },
        set: function (value) {
            this.setRouter(value);
        },
        enumerable: true,
        configurable: true
    });
    Component.prototype.setRouter = function (router) {
        this._router = router;
    };
    Object.defineProperty(Component.prototype, "dashboard", {
        get: function () {
            var p = this.parent;
            if (p === this) {
                console.warn("-- Dashboard Resolution Cycle Detected");
                return undefined;
            }
            return p ? p.dashboard : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Component.prototype.remove = function (comp) {
        // does nothing by default
    };
    Component.prototype.removeFromParent = function () {
        if (this.parent) {
            this.parent.remove(this);
            this.parent = undefined;
        }
    };
    Component.prototype.replace = function (newItem, oldItem) {
        // does nothing by default
    };
    Object.defineProperty(Component.prototype, "config", {
        get: function () {
            // default impl
            return undefined;
        },
        set: function (value) {
            this.setConfig(value);
        },
        enumerable: true,
        configurable: true
    });
    Component.prototype.setConfig = function (config) {
        // does nothing
    };
    Component.prototype._visitChildren = function (callback) {
        // does nothing by default
    };
    Component.prototype.visit = function (callback) {
        callback(this);
    };
    Component.prototype._findFirstChild = function (predicate) {
        return undefined;
    };
    Component.prototype.findFirst = function (predicate) {
        if (predicate(this)) {
            return this;
        }
        return this._findFirstChild(predicate);
    };
    Component.prototype._findAllChildren = function (predicate) {
        return [];
    };
    Component.prototype.findAll = function (predicate) {
        var r = [];
        if (predicate(this)) {
            r.push(this);
        }
        var tr = this._findAllChildren(predicate);
        if (tr && tr.length > 0) {
            r = r.concat(tr);
        }
        return r;
    };
    Component.prototype.close = function () {
        // does nothing by default
    };
    Component.prototype.toJSON = function () {
        return this.config;
    };
    __decorate([
        mobx_1.observable.ref
    ], Component.prototype, "parent", void 0);
    __decorate([
        mobx_1.observable.ref
    ], Component.prototype, "_portalManager", void 0);
    __decorate([
        mobx_1.observable.ref
    ], Component.prototype, "_componentFactory", void 0);
    __decorate([
        mobx_1.observable.ref
    ], Component.prototype, "_addApp", void 0);
    __decorate([
        mobx_1.observable.ref
    ], Component.prototype, "_router", void 0);
    __decorate([
        mobx_1.observable
    ], Component.prototype, "_x", void 0);
    __decorate([
        mobx_1.observable
    ], Component.prototype, "_y", void 0);
    __decorate([
        mobx_1.observable
    ], Component.prototype, "_width", void 0);
    __decorate([
        mobx_1.observable
    ], Component.prototype, "_height", void 0);
    __decorate([
        mobx_1.computed
    ], Component.prototype, "root", null);
    __decorate([
        mobx_1.computed
    ], Component.prototype, "x", null);
    __decorate([
        mobx_1.computed
    ], Component.prototype, "rx", null);
    __decorate([
        mobx_1.computed
    ], Component.prototype, "y", null);
    __decorate([
        mobx_1.computed
    ], Component.prototype, "ry", null);
    __decorate([
        mobx_1.computed
    ], Component.prototype, "width", null);
    __decorate([
        mobx_1.computed
    ], Component.prototype, "height", null);
    __decorate([
        mobx_1.action
    ], Component.prototype, "resize", null);
    __decorate([
        mobx_1.action
    ], Component.prototype, "position", null);
    __decorate([
        mobx_1.action
    ], Component.prototype, "setViewport", null);
    __decorate([
        mobx_1.computed
    ], Component.prototype, "addApp", null);
    __decorate([
        mobx_1.computed
    ], Component.prototype, "portalManager", null);
    __decorate([
        mobx_1.action
    ], Component.prototype, "setPortalManager", null);
    __decorate([
        mobx_1.computed
    ], Component.prototype, "componentFactory", null);
    __decorate([
        mobx_1.action
    ], Component.prototype, "setComponentFactory", null);
    __decorate([
        mobx_1.action
    ], Component.prototype, "setAddApp", null);
    __decorate([
        mobx_1.computed
    ], Component.prototype, "router", null);
    __decorate([
        mobx_1.action
    ], Component.prototype, "setRouter", null);
    __decorate([
        mobx_1.computed
    ], Component.prototype, "dashboard", null);
    __decorate([
        mobx_1.action
    ], Component.prototype, "setConfig", null);
    __decorate([
        mobx_1.action
    ], Component.prototype, "close", null);
    return Component;
}());
exports.Component = Component;
